/* Presentation only: Audien's two-step dialog has no public surface part. */
(() => {
  const tags = ['two-steps-write', 'write-review-modal'];
  const selector = tags.join(',');
  const css = `
    .audien-write-container,.step-1,.step-2{background:#f8f5ef!important;color:#19161b!important}
    .audien-write-container{border:1px solid #c7b8a5;border-radius:4px!important;font-family:var(--font-body-family,Arial,sans-serif)}
    .audien-write-header,.step-2-header,.step-1-header,.step-title{font-family:Georgia,serif!important;font-weight:500!important;color:#681728!important}
    .input-style{background:#fffdf9!important;color:#19161b!important;border-color:#9c8977!important;border-radius:3px!important}
    .next-step{background:#681728!important;color:white!important;border-radius:3px!important}
    .coupons-wrap{background:#eee4d5!important}
  `;
  const brand = host => {
    const root = host.shadowRoot;
    if (!root || root.querySelector('[data-iml-review-brand]')) return;
    const style = document.createElement('style');
    style.dataset.imlReviewBrand = '';
    style.textContent = css;
    root.append(style);
  };
  const scan = node => {
    if (!(node instanceof Element)) return;
    if (node.matches(selector)) brand(node);
    node.querySelectorAll(selector).forEach(brand);
  };
  tags.forEach(tag => customElements.whenDefined(tag).then(() => scan(document.body)));
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(scan)))
    .observe(document.body, { childList: true, subtree: true });
})();
